import type { MinimalCurvatureParams, MovingAverageParams } from '@core/core/types'
import type { Nullable } from '@library/types'

export const isValidMaxDescrepancyParam = (params: Nullable<MinimalCurvatureParams>) =>
  params ? params.maxDiscrepancy > 0 : true

export const isValidIterationsCountParam = (params: Nullable<MinimalCurvatureParams>) =>
  params ? params.iterationsCount > 0 : true

export const isValidNeighborParam = (params: Nullable<MovingAverageParams>) =>
  params ? params.neighborsCount > 0 : true

export const isValidAnisatropyAngleParam = (params: Nullable<MovingAverageParams>) =>
  params ? params.anisotropyAngle !== null : true

export const isValidBigRadiusParam = (params: Nullable<MovingAverageParams>) =>
  params ? params.ellipseBigRadius > 0 : true

export const isValidSmallRadiusParam = (params: Nullable<MovingAverageParams>) =>
  params ? params.ellipseSmallRadius > 0 : true
